import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

import DialogModal from '../../common/DialogModal';
import { isOrderScheduledAfter } from "../../../utils/utils.js";
import moment from 'moment';

const styles = theme => ({
  text: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },

  button: {
    border: 'solid 1px #D8DBDF',
    color: '#181819',
    fontSize: '13px',
    margin: '30px',
  },

  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
  },

  contentContainer: {
    margin: 0,
    padding: '20px 115px',
    textAlign: 'unset',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

class LetterOrderCompleteDialog extends React.Component {
  render() {
    const { classes, isOpen, toggleDialog, time, buttonText, orderScheduledAt } = this.props;
    const isScheduledAfter = isOrderScheduledAfter(orderScheduledAt)
    let orderCompleteMesssage = '注文を承りました'
    let orderCompleteTitle = '注文完了'
    if (isScheduledAfter) {
      orderCompleteMesssage = '注文の予約を承りました'
      orderCompleteTitle = '注文予約完了'
    }

    return (
      <DialogModal
        title={orderCompleteTitle}
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <img alt="注文完了" src={require('../../../assets/images/create-campaign-completed@2x.png')} height="300" />

        <Typography variant="subheading" style={{ fontWeight: 'bold', marginTop: '30px' }}>{orderCompleteMesssage}</Typography>

        <Typography variant="body2" style={{ marginTop: '15px' }}>発送予定日は、{moment(time).format('YYYY年MM月DD日')}です。</Typography>
        <Typography variant="body2">印刷工場の稼働状況によって2〜3日ほど前後する場合があります。</Typography>

        <Button color="default" onClick={toggleDialog} className={classes.button}>
          {buttonText ? buttonText : 'タイムラインを確認'}
        </Button>
      </DialogModal>
    );
  }
}

LetterOrderCompleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  time: PropTypes.string,
  orderScheduledAt: PropTypes.string,
};

export default withStyles(styles)(LetterOrderCompleteDialog);



// WEBPACK FOOTER //
// ./src/components/Timeline/dialogs/LetterOrderCompleteDialog.jsx